import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const FeaturedVoiceSkeletonWrapper = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr 1fr',
  alignItems: 'center',
  gap: '16px',
  width: '100%',
  flexDirection: 'column',
}));

const InfoGroup = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

const VoiceSkeletonWrapper = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr 1fr',
  alignItems: 'center',
  gap: '16px',
  padding: '8px',
}));

const ActionsGroup = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  marginLeft: 'auto',
  marginRight: '9px',
}));

export {
  VoiceSkeletonWrapper,
  InfoGroup,
  ActionsGroup,
  FeaturedVoiceSkeletonWrapper,
};
